import { render, staticRenderFns } from "./appLink.vue?vue&type=template&id=5434bd79&scoped=true&"
import script from "./appLink.vue?vue&type=script&lang=js&"
export * from "./appLink.vue?vue&type=script&lang=js&"
import style0 from "./appLink.vue?vue&type=style&index=0&id=5434bd79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5434bd79",
  null
  
)

export default component.exports